import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {AngularFireAuthGuard, redirectLoggedInTo, redirectUnauthorizedTo} from '@angular/fire/auth-guard';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['accedi']);
const redirectLoggedInToHome = () => redirectLoggedInTo(['profilo']);

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'accedi',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthPageModule),
    canActivate: [AngularFireAuthGuard],
    data: {
      authGuardPipe: redirectLoggedInToHome,
      roles: []
    },
  },
  {
    path: 'profilo',
    loadChildren: () => import('./profile/profile.module').then(m => m.ProfilePageModule),
    canActivate: [AngularFireAuthGuard],
    data: {
      authGuardPipe: redirectUnauthorizedToLogin,
      roles: []
    },
  },
  {
    path: 'termini-e-condizioni',
    loadChildren: () => import('./terms-conditions/terms-conditions.module').then(m => m.TermsConditionsPageModule)
  },
  {
    path: 'boccio',
    redirectTo: 'sporting',
   // loadChildren: () => import('./boccio/boccio.module').then(m => m.BoccioPageModule)
  },
  {
    path: 'sporting',
    loadChildren: () => import('./sporting/sporting.module').then( m => m.SportingPageModule)
  },
  {
    path: 'bistrot',
    loadChildren: () => import('./bistrot/bistrot.module').then( m => m.BistrotPageModule)
  },

  {
    path: ':locale-id',
    loadChildren: () => import('./local-name/local-name.module').then(m => m.LocalNamePageModule)
  },

  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
